import { DateTime } from 'luxon';

import { SummaryCounter } from '@common/models';

export class ServiceSummaryCounter
{
    summaryCounters: SummaryCounter<string>[] = [];
}

export class DashServiceSummaryCounter extends ServiceSummaryCounter
{
    public isEmpty: boolean = false;
    public isLoading: boolean = true;
    public isLoaded: boolean = false;
    public isOups: boolean = false;
    public expirationDate?: DateTime;
}
